import { Component, h, State } from '@stencil/core';
import { AnchorLink } from './anchor-link.interface';

@Component({
  tag: 'kdx-anchor-links',
  styleUrl: 'anchor-links.scss',
  shadow: false,
})
export class AnchorLinks {

  @State() anchorLinks: Array<AnchorLink> = [];

  componentWillLoad() {
    // Poll app for hydrated flag then give time for UI to settle before building buttons.
    const appLoadedPoll = setInterval(() => {
      const hydrated = document.querySelector('html.hydrated');

      if (hydrated) {
        setTimeout(() => {
          this.buildAnchors();
        }, 500);
        window.clearInterval(appLoadedPoll);
      }

    }, 100);
  }

  buildAnchors() {
    this.anchorLinks = [];
    const contentH2 = document.querySelectorAll('#content h2');

    let afterAnchorPlacement = false;

    contentH2.forEach((h2: HTMLElement) => {
      const text = h2.innerText;

      // Only get H2s that appear after this component
      if (h2.classList.contains('anchor-links-placement')) {
        afterAnchorPlacement = true;
      }

      if (afterAnchorPlacement && text && text != '' && !h2.classList.contains('subheading')){
        let id = h2.getAttribute('id');

        if (!id) {
          id = text.replace(/[^A-Z0-9]/ig, "-");
          h2.setAttribute('id', id);
        }
  
        this.anchorLinks.push({
          title: text,
          id: id
        });
      }
    });
  }

  render() {
    return (
      <div class="kdx-anchor-links">
        <div class="kdx-anchor-links-header">Jump to section...</div>
        <div class="kdx-anchor-links-body">
          {/* Hidden H2 used for tracking so we can not show any H2s that were above this component */}
          <h2 class="anchor-links-placement" style={{ display: 'none' }}></h2>

          {this.anchorLinks.map((link) => (
            <a href={`#${link.id}`} aria-label={`Go to ${link.title}`} class="btn btn-primary">
              {link.title}
            </a>
          ))}
        </div>
      </div>
    );
  }
}

